<template>
    <div class="full-width">
        <div class="content-part">
            <span class="title-span" tkey="標題">{{i18n.tkey("lang_title")}}</span>
            <br>
            <el-input
                v-model="currRecord.addinfo1"
                :placeholder="i18n.tkey('lang_title')"
                :prefix-icon="Search"
                clearable
                maxlength="60"
            />
        </div>

        <div class="content-part">
            <span class="title-span" tkey="時間">{{i18n.tkey("lang_time")}}</span>
            <el-input type="date" v-model="currRecord.addinfo2" />
        </div>

        <div class="content-part">
            <span class="title-span" tkey="內容">{{i18n.tkey("lang_content")}}</span>
            <el-input
                v-model="currRecord.addremark1"
                style="width: 100%"
                :rows="6"
                type="textarea"
                :placeholder="i18n.tkey('lang_information_content')"
            />
        </div>

        <div class="content-part">
            <span class="title-span" tkey="圖片">{{i18n.tkey("lang_img")}}</span>
            <div class="img-box">
                <div class="img-part" v-for="(v, i) in fileformatList" :key="i + 100000">
                    <img class="preview-img" :src="staticPath + v.filename">
                    <span class="del-btn" @click="delImgFile(i)"><font-awesome-icon icon="fa-solid fa-xmark" /></span>
                </div>

                <div class="img-part" v-for="(v, i) in imgs" :key="i + new Date().getTime()">
                    <img class="preview-img" :src="v">
                    <span class="del-btn" @click="delImgs(i)"><font-awesome-icon icon="fa-solid fa-xmark" /></span>
                </div>

                <uploadImg :useBtn="false" v-if="(imgs.length + fileformatList.length < 3) && uploadVisible" @selectComplete="uploadComplete" />
            </div>
        </div>

        <div class="operation-box">
            <el-button type="primary" @click="submitInsert" v-if="null == editObj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
            <el-button type="primary" @click="submitEdit" v-if="null != editObj" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </div>
    </div>
</template>

<script setup>
    //響應機制的userinfo
    import {toRef, ref, onMounted, getCurrentInstance, inject} from "vue";
    import uploadImg from "@/components/shopopee/form/uploadImg"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faXmark } from '@fortawesome/free-solid-svg-icons'
    import record5Api from "@/request/record5Api";
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";
    const userInfoRef = toRef(useUserinfo())

    library.add(faXmark)

    const props = defineProps(["editObj"])
    const emits = defineEmits(["addComplete", "editComplete"])

    const i18n = inject("i18n")

    const { proxy } = getCurrentInstance()

    const staticPath = proxy.$ShopopeeUrl

    const currRecord = ref({
        addinfo1: null,
        addinfo2: null,
        addinfo4: null,
        addremark1: null,
        companycode: null,
        imgs: [],
        recordno: 1
    })
    const imgs = ref([])
    const fileformatList = ref([])
    const uploadVisible = ref(true)
    const deleteFileList = ref([])

    function delImgs(index){
        imgs.value.splice(index, 1)
    }

    function delImgFile(index){
        fileformatList.value[index].status = 0
        deleteFileList.value.push(fileformatList.value[index])
        fileformatList.value.splice(index, 1)
    }

    function uploadComplete(src){
        uploadVisible.value = false
        imgs.value.push(src)

        setTimeout(() => {
            uploadVisible.value = true
        }, 150)
    }

    function submitEdit(){
        const request = record5Api.editRecord
        const params = request.getParams()

        params.addinfo1 = currRecord.value.addinfo1
        params.addinfo2 = currRecord.value.addinfo2.replaceAll("-", "/")
        params.addinfo4 = currRecord.value.addinfo4
        params.addremark1 = currRecord.value.addremark1
        params.id = currRecord.value.id
        params.recordno = currRecord.value.recordno
        params.updatedid = currRecord.value.updatedid
        params.fileformatList = fileformatList.value.concat(deleteFileList.value)
        params.imgs = imgs.value

        request.send(params, (res) => {
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                emits("editComplete")
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function submitInsert(){
        const request = record5Api.insertRecord
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.addinfo1 = currRecord.value.addinfo1
        params.addinfo2 = currRecord.value.addinfo2.replaceAll("-", "/")
        params.addinfo4 = currRecord.value.addinfo4
        params.addremark1 = currRecord.value.addremark1
        params.imgs = imgs.value

        request.send(params, (res) => {
            if (res.code == 200){
                if (res.code == 200){
                    myUtil.alertSuccess(i18n.tkey("lang_submit_success"))
                    emits("addComplete")
                }else{
                    myUtil.alertError(res.msg)
                }
            }
        })

    }

    onMounted(() => {
        if (null != props.editObj){
            currRecord.value = props.editObj
            currRecord.value.addinfo2 = props.editObj.addinfo2.replaceAll("/", "-")
            fileformatList.value = props.editObj.fileformatList
        }

    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        text-align: left;
    }

    .title-span {
        font-size: 14px;
        color: #606266;
    }

    .content-part {
        margin-bottom: 15px;
    }

    .img-box {
        margin-top: 15px;
        display: flex;
    }

    .img-part {
        width: 100px;
        height: 100px;
        position: relative;
        margin-right: 10px;
    }

    .preview-img {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }

    .del-btn {
        top: 2px;
        right: 2px;
        font-size: 24px;
        color: #ff0000;
        display: inline-block;
        cursor: pointer;
        position: absolute;
    }

    .operation-box {
        text-align: center;
        margin-top: 20px;
    }
</style>